import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_frame')({
  component: FrameLayoutComponent,
})

function FrameLayoutComponent() {
  return <Outlet />
}
